// @flow
import {
  SEARCH_DECREASE_PAGE,
  SEARCH_INCREASE_PAGE,
  SEARCH_SET_CRITERIA,
  SEARCH_SET_DOCUMENTS_PER_PAGE,
  SEARCH_SET_PAGE,
  SEARCH_SET_YEARS_MUST_USE
} from '../reducers/search';
import SearchAPI from '../library/SearchAPI';

import type { SetCriteria } from '../types/Criteria';
import { RESULTS_LOADING, RESULTS_SUCCESS } from '../reducers/results';
import {
  FACETS_ERROR,
  FACETS_LOADING,
  FACETS_CANCEL_LOADING,
  FACETS_SUCCESS
} from '../reducers/facets';
import {
  TRANSLATIONS_ERROR,
  TRANSLATIONS_SUCCESS
} from '../reducers/translations';

const setCriteria = (payload: SetCriteria) => ({
  type: SEARCH_SET_CRITERIA,
  payload
});

const setYearsMustUse = (payload: boolean) => ({
  type: SEARCH_SET_YEARS_MUST_USE,
  payload
});

const setDocumentsPerPage = (documentsPerPage: string) => ({
  type: SEARCH_SET_DOCUMENTS_PER_PAGE,
  payload: {
    documentsPerPage: parseInt(documentsPerPage, 0)
  }
});

const makeSearch = () => async (dispatch: Function, getState: Function) => {
  const {
    adv,
    query,
    pagination,
    platforms,
    access,
    type,
    author,
    translations,
    journalsPublications,
    booksPublications,
    hypothesesPublications,
    years,
    sort
  } = getState().search;

  const lang = getState().ui.lang;

  const sortParse = sort
    ? {
        [sort.replace('-', '')]: /^-/.test(sort) ? 'desc' : 'asc'
      }
    : undefined;

  const options = {
    lang,
    locale: lang,
    q: query || '*',
    facets: {
      platform: {
        options: Object.keys(platforms).filter(key => !!platforms[key])
      },
      access: {
        options: access
      },
      type: {
        options: type
      },
      author: {
        options: author
      },
      translations: {
        options: translations
      },
      'journals-publication': {
        options: journalsPublications
      },
      'books-publication': {
        options: booksPublications
      },
      'hypotheses-publication': {
        options: hypothesesPublications
      },
      date: {}
    },
    pagination,
    adv,
    sort: sortParse
  };

  if (years.mustUse) {
    options.facets.date = {
      from: years.min,
      to: years.max
    };
  }

  dispatch({
    type: RESULTS_LOADING
  });
  dispatch({
    type: FACETS_LOADING
  });

  const response = await SearchAPI.getDocuments(options);

  dispatch({
    type: RESULTS_SUCCESS,
    payload: {
      documents: response.documents,
      pagination: response.pagination
    }
  });

  if (response.documents.length > 0) {
    SearchAPI.getFacets(options)
      .then(response => {
        dispatch({
          type: FACETS_SUCCESS,
          payload: {
            counts: response.inputs
          }
        });
      })
      .catch(e =>
        dispatch({
          type: FACETS_ERROR,
          payload: {
            error: e
          }
        })
      );

    SearchAPI.getTranslations(options)
      .then(response => {
        dispatch({
          type: TRANSLATIONS_SUCCESS,
          payload: response
        });
      })
      .catch(e =>
        dispatch({
          type: TRANSLATIONS_ERROR,
          payload: {
            error: e
          }
        })
      );
  } else {
    dispatch({
      type: FACETS_CANCEL_LOADING
    });
  }
};

const goToNextPage = (currentPage: number, totalPage: number) => {
  return currentPage < totalPage
    ? {
        type: SEARCH_INCREASE_PAGE
      }
    : {
        type: 'do_nothing'
      };
};

const goToPrevPage = () => ({
  type: SEARCH_DECREASE_PAGE
});

const goToPage = (pageNumber: number, totalPage: number) => {
  const pageMinor = pageNumber < 1 ? 1 : pageNumber;
  const payload = parseInt(pageMinor > totalPage ? totalPage : pageMinor, 0);

  return {
    type: SEARCH_SET_PAGE,
    payload
  };
};

export {
  setCriteria,
  setDocumentsPerPage,
  makeSearch,
  goToPrevPage,
  goToNextPage,
  goToPage,
  setYearsMustUse
};



// WEBPACK FOOTER //
// ./src/actions/search.js